module.exports = __webpack_public_path__ + "static/media/94024559CD27455CA7ADE8DA3060F7F7.c2a486c3.jpg";